import { jsx as _jsx } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import { useBranding } from "../BrandingProvider/BrandingProvider";
import { useCompany } from "../CompanyProvider/CompanyProvider";
import { ConditionalLink } from "../ConditionalLink";
import { BrandLogo } from "./BrandLogo";
/**
 * Brand Logo component that links to the company's website.
 * @param logoStyles
 * @param typographyVariant - defaults to an h3 element
 * @returns
 */
export const BrandLogoLink = ({ logoStyles, typographyVariant = "h3", typographyColor = "primary", }) => {
    var _a;
    const { imgBaseUrl, url } = useCompany();
    const { branding } = useBranding();
    return (_jsx(ConditionalLink, Object.assign({ url: url }, { children: ((_a = branding.BrandLogo) === null || _a === void 0 ? void 0 : _a.FileUpload) ? (_jsx(BrandLogo, Object.assign({}, { branding, imgBaseUrl, logoStyles, typographyVariant, typographyColor }))) : (_jsx(Typography, Object.assign({ variant: typographyVariant, color: typographyColor }, { children: branding.BrandDisplayName.Input }))) })));
};
